import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-daff19ae")

_pushScopeId("data-v-daff19ae")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "p-d-flex p-flex-row kn-page-content" }
const _hoisted_3 = {
  key: 0,
  class: "card kn-flex"
}
const _hoisted_4 = {
  key: 1,
  class: "listbox p-d-flex p-flex-column"
}
const _hoisted_5 = {
  key: 2,
  class: "listbox p-d-flex p-flex-column"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_MeasureDefinitionQueryCard = _resolveComponent("MeasureDefinitionQueryCard")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MeasureDefinitionMetadataCard = _resolveComponent("MeasureDefinitionMetadataCard")
  const _component_TabView = _resolveComponent("TabView")
  const _component_MeasureDefinitionFilterList = _resolveComponent("MeasureDefinitionFilterList")
  const _component_MeasureDefinitionSubmitDialog = _resolveComponent("MeasureDefinitionSubmitDialog")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-rounded kn-button",
            label: _ctx.$t('kpi.measureDefinition.alias'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.aliasesVisible = !_ctx.aliasesVisible)),
            "data-test": "submit-button"
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-rounded kn-button",
            label: _ctx.$t('kpi.measureDefinition.placeholder'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.placeholderVisible = !_ctx.placeholderVisible)),
            "data-test": "submit-button"
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "p-button-text p-button-rounded p-button-plain",
            disabled: _ctx.metadataDisabled,
            onClick: _ctx.submitConfirm,
            "data-test": "submit-button"
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.closeTemplate,
            "data-test": "close-button"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_TabView, {
                activeIndex: _ctx.activeTab,
                "onUpdate:activeIndex": _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = $event)),
                onTabChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setTabChanged($event.index)))
              }, {
                default: _withId(() => [
                  _createVNode(_component_TabPanel, null, {
                    header: _withId(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.measureDefinition.query')), 1)
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_MeasureDefinitionQueryCard, {
                        rule: _ctx.rule,
                        datasourcesList: _ctx.datasourcesList,
                        aliases: _ctx.availableAliasList,
                        placeholders: _ctx.placeholdersList,
                        columns: _ctx.columns,
                        rows: _ctx.rows,
                        codeInput: _ctx.codeInput,
                        preview: _ctx.preview,
                        onQueryChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.queryChanged = true)),
                        onLoadPreview: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewQuery(false, true, true))),
                        onClosePreview: _cache[5] || (_cache[5] = ($event: any) => (_ctx.preview = false))
                      }, null, 8, ["rule", "datasourcesList", "aliases", "placeholders", "columns", "rows", "codeInput", "preview"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_TabPanel, { disabled: _ctx.metadataDisabled }, {
                    header: _withId(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.measureDefinition.metadata')), 1)
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_MeasureDefinitionMetadataCard, {
                        currentRule: _ctx.rule,
                        tipologiesType: _ctx.domainsKpiRuleoutput,
                        domainsTemporalLevel: _ctx.domainsTemporalLevel,
                        categories: _ctx.domainsKpiMeasures,
                        onTouched: _ctx.setTouched
                      }, null, 8, ["currentRule", "tipologiesType", "domainsTemporalLevel", "categories", "onTouched"])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["activeIndex"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.aliasesVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_MeasureDefinitionFilterList, {
                header: _ctx.$t('kpi.measureDefinition.alias'),
                list: _ctx.availableAliasList,
                listType: "alias",
                onSelected: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setCodeInput($event)))
              }, null, 8, ["header", "list"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.placeholderVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_MeasureDefinitionFilterList, {
                header: _ctx.$t('kpi.measureDefinition.placeholder'),
                list: _ctx.placeholdersList,
                listType: "placeholder",
                onSelected: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setCodeInput($event)))
              }, null, 8, ["header", "list"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showSaveDialog)
      ? (_openBlock(), _createBlock(_component_MeasureDefinitionSubmitDialog, {
          key: 0,
          ruleName: _ctx.rule.name,
          newAlias: _ctx.newAlias,
          reusedAlias: _ctx.reusedAlias,
          newPlaceholder: _ctx.newPlaceholder,
          reusedPlaceholder: _ctx.reusedPlaceholder,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSaveDialog = false)),
          onSave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveRule($event)))
        }, null, 8, ["ruleName", "newAlias", "reusedAlias", "newPlaceholder", "reusedPlaceholder"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      autoZIndex: false,
      style: _ctx.metadataDefinitionTabViewDescriptor.errorDialog.style,
      modal: true,
      visible: _ctx.errorDialogVisible,
      header: _ctx.errorTitle,
      class: "full-screen-dialog p-fluid kn-dialog--toolbar--primary error-dialog",
      closable: false
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--secondary",
          label: _ctx.$t('common.close'),
          onClick: _ctx.closeErrorMessageDialog
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withId(() => [
        _createVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["style", "visible", "header"])
  ], 64))
})